function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
import { urlSearchParams } from "../constants";
export var GET_USERFOLLOWERLISTITEMSBYFOLLOWEEIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_REQUEST = "GET_USERFOLLOWERLISTITEMSBYFOLLOWEEIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_REQUEST";
export var GET_USERFOLLOWERLISTITEMSBYFOLLOWEEIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_SUCCESS = "GET_USERFOLLOWERLISTITEMSBYFOLLOWEEIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_SUCCESS";
export var GET_USERFOLLOWERLISTITEMSBYFOLLOWEEIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_FAILURE = "GET_USERFOLLOWERLISTITEMSBYFOLLOWEEIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_FAILURE";
export var RESET_GET_USERFOLLOWERLISTITEMSBYFOLLOWEEIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID = "RESET_GET_USERFOLLOWERLISTITEMSBYFOLLOWEEIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID";

// Fetches followers for a particular user and followee from Front API.
// Relies on the custom API middleware defined in ../middleware/api.js.
export var fetchUserFollowerListItemsByFolloweeIdAndConfirmedAtNotNullAndAuthUserId = function fetchUserFollowerListItemsByFolloweeIdAndConfirmedAtNotNullAndAuthUserId(followeeId, authUserId, maxId, sinceId, count) {
  var queryString = urlSearchParams({
    followeeId: followeeId,
    authUserId: authUserId,
    maxId: maxId,
    sinceId: sinceId,
    count: count
  });
  return _defineProperty({
    followeeId: followeeId,
    authUserId: authUserId,
    maxId: maxId,
    sinceId: sinceId,
    count: count
  }, CALL_API, {
    types: [GET_USERFOLLOWERLISTITEMSBYFOLLOWEEIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_REQUEST, GET_USERFOLLOWERLISTITEMSBYFOLLOWEEIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_SUCCESS, GET_USERFOLLOWERLISTITEMSBYFOLLOWEEIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_FAILURE],
    endpoint: "userFollowerListItems/search/findByFolloweeIdAndConfirmedAtNotNullAndAuthUserId".concat(queryString),
    init: {
      credentials: "same-origin"
    }
  });
};
export var GET_USERFOLLOWERLISTITEMSBYUSERIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_REQUEST = "GET_USERFOLLOWERLISTITEMSBYUSERIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_REQUEST";
export var GET_USERFOLLOWERLISTITEMSBYUSERIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_SUCCESS = "GET_USERFOLLOWERLISTITEMSBYUSERIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_SUCCESS";
export var GET_USERFOLLOWERLISTITEMSBYUSERIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_FAILURE = "GET_USERFOLLOWERLISTITEMSBYUSERIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_FAILURE";
export var RESET_GET_USERFOLLOWERLISTITEMSBYUSERIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID = "RESET_GET_USERFOLLOWERLISTITEMSBYUSERIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID";

// Fetches following modal for a particular user and followee from Front API.
// Relies on the custom API middleware defined in ../middleware/api.js.
export var fetchUserFollowerListItemsByUserIdAndConfirmedAtNotNullAndAuthUserId = function fetchUserFollowerListItemsByUserIdAndConfirmedAtNotNullAndAuthUserId(userId, authUserId, maxId, sinceId, count) {
  var queryString = urlSearchParams({
    userId: userId,
    authUserId: authUserId,
    maxId: maxId,
    sinceId: sinceId,
    count: count
  });
  return _defineProperty({
    userId: userId,
    authUserId: authUserId,
    maxId: maxId,
    sinceId: sinceId,
    count: count
  }, CALL_API, {
    types: [GET_USERFOLLOWERLISTITEMSBYUSERIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_REQUEST, GET_USERFOLLOWERLISTITEMSBYUSERIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_SUCCESS, GET_USERFOLLOWERLISTITEMSBYUSERIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_FAILURE],
    endpoint: "userFollowerListItems/search/findByUserIdAndConfirmedAtNotNullAndAuthUserId".concat(queryString),
    init: {
      credentials: "same-origin"
    }
  });
};